// src/MathTools/LogarithmGraphTool.js
import React, { useState } from "react";
import CoordinatePlane from "./CoordinatePlane";

/**
 * A small tool to plot y=log_b(x) for x>0, letting user pick the base b.
 */
export default function LogarithmGraphTool({
  initialBase = 2,
  xMin = 0.1,
  xMax = 10,
  width = 400,
  height = 300
}) {
  const [base, setBase] = useState(initialBase);

  // Recompute the log curve each render (i.e. when base changes).
  // We'll sample x from xMin..xMax and get y = log_base(x) = ln(x)/ln(base).
  const stepCount = 100;
  const dx = (xMax - xMin) / stepCount;

  const lines = [];
  let minY = Infinity;
  let maxY = -Infinity;

  // If base <=0 or base==1 => log is undefined => skip
  if (base > 0 && base !== 1) {
    for (let i = 0; i <= stepCount; i++) {
      const xVal = xMin + i * dx;
      if (xVal <= 0) continue; // x must be positive

      const yVal = Math.log(xVal) / Math.log(base); // log_base(x)
      if (!Number.isFinite(yVal)) continue;

      lines.push({
        start: [xVal, yVal],
        end:   [xVal, yVal],
        color: "blue"
      });

      if (yVal < minY) minY = yVal;
      if (yVal > maxY) maxY = yVal;
    }
  }

  // If we have no valid points => fallback or zero lines
  if (lines.length < 2) {
    // e.g. if base<=0 or base==1, or xMin>0. 
    // We'll just store empty lines and let the plane show no plot
    minY = -1;
    maxY = 1;
  }

  // A small padding for Y domain
  const pad = 0.1 * (maxY - minY);
  const yLower = minY - pad;
  const yUpper = maxY + pad;

  return (
<div style={{ border: "1px solid #ccc", padding: 8 }}>
  <h4>Logarithm Graph (y = log<sub>b</sub>(x))</h4>

  {/* 在這裡插入「Base」input */}
  <div style={{ marginBottom: 8 }}>
    <label>
      Base b:{" "}
      <input
        type="number"
        step="0.1"
        min="0.01"
        value={base}
        onChange={e => setBase(Number(e.target.value))}
        style={{ width: 60 }}
      />
    </label>
    {base <= 0 && <span style={{ color: "red", marginLeft: 8 }}>Base must be &gt; 0</span>}
    {base === 1 && <span style={{ color: "red", marginLeft: 8 }}>Base cannot be 1</span>}
  </div>

  <CoordinatePlane
    width={width}
    height={height}
    xDomain={[xMin, xMax]}
    yDomain={[yLower, yUpper]}
    lines={lines}
    showAxes
    axisMode="border"
    disablePlot={true}
  />

  <p style={{ fontStyle: "italic", fontSize: "0.9em", marginTop: 8 }}>
    Plots <strong>y = log<sub>b</sub>(x)</strong> for x &gt; 0, base b = {base}.
    <br />
    Adjust the base above to see how the log curve’s shape changes.
  </p>
</div>
  );
}
